import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconInstagram(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Instagram">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 24.5C21 26.4334 22.5666 28 24.5 28C26.4334 28 28 26.4334 28 24.5C28 22.5672 26.4322 21 24.5 21C22.5678 21 21 22.5672 21 24.5ZM24.5 32C20.3575 32 17 28.6425 17 24.5C17 20.3575 20.3593 17 24.5 17C28.6407 17 32 20.3575 32 24.5C32 28.6425 28.6425 32 24.5 32Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M33 16C33 17.1046 32.1046 18 31 18C29.8954 18 29 17.1046 29 16C29 14.8954 29.8954 14 31 14C32.1046 14 33 14.8954 33 16Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30 12H18C14.6863 12 12 14.6863 12 18V30C12 33.3137 14.6863 36 18 36H30C33.3137 36 36 33.3137 36 30V18C36 14.6863 33.3137 12 30 12ZM18 8C12.4772 8 8 12.4772 8 18V30C8 35.5228 12.4772 40 18 40H30C35.5228 40 40 35.5228 40 30V18C40 12.4772 35.5228 8 30 8H18Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40 2H8C4.68629 2 2 4.68629 2 8V40C2 43.3137 4.68629 46 8 46H40C43.3137 46 46 43.3137 46 40V8C46 4.68629 43.3137 2 40 2ZM8 0C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0H8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconInstagramInverted(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Instagram">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0H8ZM18 12H30C33.3137 12 36 14.6863 36 18V30C36 33.3137 33.3137 36 30 36H18C14.6863 36 12 33.3137 12 30V18C12 14.6863 14.6863 12 18 12ZM8 18C8 12.4772 12.4772 8 18 8H30C35.5229 8 40 12.4772 40 18V30C40 35.5229 35.5229 40 30 40H18C12.4772 40 8 35.5229 8 30V18ZM21 24.5C21 26.4334 22.5666 28 24.5 28C26.4334 28 28 26.4334 28 24.5C28 22.5672 26.4322 21 24.5 21C22.5678 21 21 22.5672 21 24.5ZM24.5 32C20.3575 32 17 28.6425 17 24.5C17 20.3575 20.3593 17 24.5 17C28.6407 17 32 20.3575 32 24.5C32 28.6425 28.6425 32 24.5 32ZM31 18C32.1046 18 33 17.1046 33 16C33 14.8954 32.1046 14 31 14C29.8954 14 29 14.8954 29 16C29 17.1046 29.8954 18 31 18Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconInstagramOutline24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Instagram">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 12C6 8.68587 8.68741 6 12 6C15.3126 6 18 8.68587 18 12C18 15.314 15.314 18 12 18C8.68603 18 6 15.314 6 12ZM12 8C9.79166 8 8 9.79076 8 12C8 14.2094 9.7906 16 12 16C14.2094 16 16 14.2094 16 12C16 9.79076 14.2083 8 12 8Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M20 5.5C20 6.32843 19.3284 7 18.5 7C17.6716 7 17 6.32843 17 5.5C17 4.67157 17.6716 4 18.5 4C19.3284 4 20 4.67157 20 5.5Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 2H8C4.68629 2 2 4.68629 2 8V16C2 19.3137 4.68629 22 8 22H16C19.3137 22 22 19.3137 22 16V8C22 4.68629 19.3137 2 16 2ZM8 0C3.58172 0 0 3.58172 0 8V16C0 20.4183 3.58172 24 8 24H16C20.4183 24 24 20.4183 24 16V8C24 3.58172 20.4183 0 16 0H8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconInstagramNoBox48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Instagram">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 24C12 17.3719 17.3748 12 24 12C30.6252 12 36 17.3719 36 24C36 30.628 30.628 36 24 36C17.372 36 12 30.628 12 24ZM24 14C18.4791 14 14 18.4767 14 24C14 29.5234 18.4766 34 24 34C29.5234 34 34 29.5234 34 24C34 18.4767 29.5209 14 24 14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 12C37.5523 12 38 11.5523 38 11C38 10.4477 37.5523 10 37 10C36.4477 10 36 10.4477 36 11C36 11.5523 36.4477 12 37 12ZM37 14C38.6569 14 40 12.6569 40 11C40 9.34315 38.6569 8 37 8C35.3431 8 34 9.34315 34 11C34 12.6569 35.3431 14 37 14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34 2H14C7.37258 2 2 7.37258 2 14V34C2 40.6274 7.37258 46 14 46H34C40.6274 46 46 40.6274 46 34V14C46 7.37258 40.6274 2 34 2ZM14 0C6.26801 0 0 6.26801 0 14V34C0 41.732 6.26801 48 14 48H34C41.732 48 48 41.732 48 34V14C48 6.26801 41.732 0 34 0H14Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconInstagramNoBox24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Instagram">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 12C6 8.68587 8.68741 6 12 6C15.3126 6 18 8.68587 18 12C18 15.314 15.314 18 12 18C8.68603 18 6 15.314 6 12ZM12 8C9.79166 8 8 9.79076 8 12C8 14.2094 9.7906 16 12 16C14.2094 16 16 14.2094 16 12C16 9.79076 14.2083 8 12 8Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M20 5.5C20 6.32843 19.3284 7 18.5 7C17.6716 7 17 6.32843 17 5.5C17 4.67157 17.6716 4 18.5 4C19.3284 4 20 4.67157 20 5.5Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 2H8C4.68629 2 2 4.68629 2 8V16C2 19.3137 4.68629 22 8 22H16C19.3137 22 22 19.3137 22 16V8C22 4.68629 19.3137 2 16 2ZM8 0C3.58172 0 0 3.58172 0 8V16C0 20.4183 3.58172 24 8 24H16C20.4183 24 24 20.4183 24 16V8C24 3.58172 20.4183 0 16 0H8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
